/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteMcpGetServer } from "../funcs/remoteMcpGetServer.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RemoteMcpServer } from "../models/components/remotemcpserver.js";
import {
  GetRemoteMcpServerRequest,
  GetRemoteMcpServerSecurity,
} from "../models/operations/getremotemcpserver.js";
import { unwrapAsync } from "../types/fp.js";
export type GetRemoteMcpServerQueryData = RemoteMcpServer;

export function prefetchGetRemoteMcpServer(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRemoteMcpServerRequest | undefined,
  security?: GetRemoteMcpServerSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetRemoteMcpServerQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetRemoteMcpServerQuery(
  client$: GramCore,
  request?: GetRemoteMcpServerRequest | undefined,
  security?: GetRemoteMcpServerSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetRemoteMcpServerQueryData>;
} {
  return {
    queryKey: queryKeyGetRemoteMcpServer({
      id: request?.id,
      slug: request?.slug,
      gramSession: request?.gramSession,
      gramKey: request?.gramKey,
      gramProject: request?.gramProject,
    }),
    queryFn: async function getRemoteMcpServerQueryFn(
      ctx,
    ): Promise<GetRemoteMcpServerQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteMcpGetServer(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetRemoteMcpServer(
  parameters: {
    id?: string | undefined;
    slug?: string | undefined;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteMcp", "getServer", parameters];
}
